"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConstraintTypeEnum_1 = require("../../model/constraint/ConstraintTypeEnum");

var Margin_1 = require("../../model/constraint/Margin");

var PriceChange_1 = require("../../model/constraint/PriceChange");
/**
 * Builds {@link RangeConstraint range constraint}.
 *
 * @author RV
 */


var RangeConstraintBuilder =
/*#__PURE__*/
function () {
  /**
   * @param type the type of constraint
   * @param range the range specification
   */
  function RangeConstraintBuilder(type, range) {
    _classCallCheck(this, RangeConstraintBuilder);

    this.type = type;
    this.range = range;
  }
  /**
   * @returns builded {@link RangeConstraint range constraint}.
   */


  _createClass(RangeConstraintBuilder, [{
    key: "build",
    value: function build() {
      switch (this.type) {
        case ConstraintTypeEnum_1.ConstraintTypeEnum.Margin:
          {
            return new Margin_1.Margin(Margin_1.Margin.schema.range.valueOf(this.range));
          }

        case ConstraintTypeEnum_1.ConstraintTypeEnum.PriceChange:
          {
            return new PriceChange_1.PriceChange(PriceChange_1.PriceChange.schema.range.valueOf(this.range));
          }

        default:
          {
            throw new Error("Illegal argument exception for given type ".concat(this.type));
          }
      }
    }
  }]);

  return RangeConstraintBuilder;
}();

exports.RangeConstraintBuilder = RangeConstraintBuilder;